import ajv from '../ajv';
import getComponentName from '../getComponentName';
import validateSchema from '../validate/validateSchema';

/**
 * Build the validator for the action payload schema
 * @private
 * @param {*} payloadSchema The schema provided by the user in config.actions[key].schema
 * @returns {Function(value, host)} The function to validate the action's payload
 */
function buildActionPayloadValidator(payloadSchema) {
	if (process.env.NODE_ENV !== 'production') {
		let validate;

		try {
			validate = ajv.compile(payloadSchema);
		} catch (e) {
			console.error(e); // eslint-disable-line no-console
			return () => false;
		}

		return function validateActionPayload(value, host) {
			const component = getComponentName(host);

			return validateSchema(validate, value, {
				pathPrefix: 'payload',
				errorPrefix: `Action payload for ${component}: `
			});
		};
	}

	return () => true;
}

export default buildActionPayloadValidator;
